"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateVisitorResponseDto = instanceOfCreateVisitorResponseDto;
exports.CreateVisitorResponseDtoFromJSON = CreateVisitorResponseDtoFromJSON;
exports.CreateVisitorResponseDtoFromJSONTyped = CreateVisitorResponseDtoFromJSONTyped;
exports.CreateVisitorResponseDtoToJSON = CreateVisitorResponseDtoToJSON;
exports.CreateVisitorResponseDtoToJSONTyped = CreateVisitorResponseDtoToJSONTyped;
/**
 * Check if a given object implements the CreateVisitorResponseDto interface.
 */
function instanceOfCreateVisitorResponseDto(value) {
    if (!('visitorId' in value) || value['visitorId'] === undefined)
        return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined)
        return false;
    return true;
}
function CreateVisitorResponseDtoFromJSON(json) {
    return CreateVisitorResponseDtoFromJSONTyped(json, false);
}
function CreateVisitorResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'visitorId': json['visitorId'],
        'expiresAt': json['expiresAt'],
    };
}
function CreateVisitorResponseDtoToJSON(json) {
    return CreateVisitorResponseDtoToJSONTyped(json, false);
}
function CreateVisitorResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'visitorId': value['visitorId'],
        'expiresAt': value['expiresAt'],
    };
}
